import {
  AppBar,
  Avatar,
  Drawer,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from "@mui/material";
import {
  AccountCircle,
  HomeOutlined,
  MenuBookOutlined,
} from "@mui/icons-material";
import MuiAlert from "@mui/lab/Alert";
import { Map } from "immutable";
import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import uberEats from "../../assets/images/IconUberEats.png";
import Establishment from "../../controller/model/Establishment";
import { DeliveraStore } from "../../controller/model/delivera/DeliveraStore";
import { StoreKeyType } from "../../controller/model/delivera/interface";
import PopinaRestaurant from "../../controller/model/popina/PopinaRestaurant";
import Service from "../../controller/model/service/Service";
import AppStore from "../../controller/store/AppStore";
import PopinaContainer from "../Popina/PopinaContainer";
import CarteContainer from "../carte/CarteContainer";
import DeliverroContainer from "../deliveroo/DeliverooContainer";
import ImageContainer from "../image/ImageContainers";
import UbereatsContainer from "../ubereats/UbereatsContainer";

import HubRiseIcon from "../../assets/images/IconHubRise.png";
import KeytchensIcon from "../../assets/images/IconKeytchens.svg";
import foxorders_v2_logo from "../../assets/images/foxorders_v2_logo.png";
import obypay_logo from "../../assets/images/logo-obypay.png";
import AuthenticationActionCreator from "../../controller/action/AuthenticationActionCreator";
import DeliverooActionCreator from "../../controller/action/DeliverooActionCreator";
import PopinaActionCreator from "../../controller/action/PopinaActionCreator";
import UbereatsActionCreator from "../../controller/action/UbereatsActionCreator";
import { FOXORDER_V2 } from "../../controller/constant/ActionConstant";
import Environment from "../../utils/Environement";
import KeytchensContainer from "../Keytchens/KeytchensContainer";
import ObypayContainer from "../Obypay/ObypayContainer";
import FoxorderContainer from "../foxorder/foxorderContainer";
import HubRiseContainer from '../hubrise/HubRiseContainer';
import LoadingComponent from "../utils/LoadingComponent";
import { styled } from "@mui/system";


const _updateState = () => {
  const stores = AppStore.stores;
  const restaurant = AppStore.restaurant;
  const services = AppStore.services;

  return {
    stores: stores,
    restaurant: restaurant,
    services: services,
  };
};

interface PropsInterface {
  establishment: Establishment;
  history: any;
  location: any;
}

interface StateInterface {
  isLoading: boolean;
  open: any | undefined;
  stores: Map<StoreKeyType, DeliveraStore>;
  showError: boolean;
  message: string | undefined;
  restaurant: PopinaRestaurant | undefined;
  services: Map<StoreKeyType, Service>;
  title: string | undefined;
  value: any;
}

class HomeContainer extends Component {
  public state: StateInterface;
  public props: PropsInterface;

  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: true,
      open: null,
      stores: AppStore.stores,
      showError: false,
      message: "",
      restaurant: AppStore.restaurant,
      services: AppStore.services,
      title: "",
      value: props.location?.pathname || "/home",
    };
    this.props = props;
    this.handleTapDisconnectButton = this.handleTapDisconnectButton.bind(this);
    this._onStateChange = this._onStateChange.bind(this);
    this._handleTapManuItem = this._handleTapManuItem.bind(this);
    this._handleCloseSnackBar = this._handleCloseSnackBar.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleMenu = this.handleMenu.bind(this);
  }

  _onStateChange() {
    this.setState(_updateState());
  }

  componentDidMount() {
    AppStore.addChangeListener(this._onStateChange);
    const allPromise = [
      PopinaActionCreator.fetchPopinaCarte(this.props.establishment),
      UbereatsActionCreator.loadUberEatServiceUser(),
      DeliverooActionCreator.loadDeliverooServiceUser(),
    ];
    Promise.all(allPromise)
      .then(() => {
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
          showError: true,
          message: `Erreur lors des données de Delivera, veuillez réessayer (erreur : ${err.message})`,
        });
      });
  }

  componentWillUnmount() {
    AppStore.removeChangeListener(this._onStateChange);
  }

  private handleTapDisconnectButton() {
    AuthenticationActionCreator.logoutEstablishment();
    this.setState({
      open: null,
    });
  }

  private _handleCloseSnackBar() {
    this.setState({ showError: false, message: "" });
  }

  private handleClose() {
    this.setState({
      open: null,
    });
  }

  private handleMenu(event: any) {
    this.setState({
      open: event.currentTarget,
    });
  }

  private _handleTapManuItem(text: string) {
    this.setState({
      title: text,
    });
    if (text.toLowerCase() === "ubereats") {
      this.props.history.push("/home/ubereats");
    }
    if (text.toLowerCase() === "deliveroo") {
      this.props.history.push("/home/deliveroo");
    }
    if (text.toLowerCase() === "popina") {
      this.props.history.push("/home/restaurant");
    }
    if (text.toLowerCase() === "jalia") {
      this.props.history.push("/home/restaurant");
    }
    if (text.toLowerCase() === "keytchens") {
        this.props.history.push("/home/keytchens");
    }
    if (text.toLowerCase() === "hubrise") {
        this.props.history.push("/home/hubrise");
    }
    if (text.toLowerCase() === "images") {
      this.props.history.push("/home/images");
    }
    if (text.toLowerCase() === "home") {
      this.props.history.push("/home");
    }
    if(text.toLowerCase() === `${FOXORDER_V2}`){
      this.props.history.push("/home/foxorderV2");
    }
    if (text.toLowerCase() === 'obypay') {
      this.props.history.push('/home/obypay');
    }
  }

  private a11yProps(index: any) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }

  handleChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    this.setState({
      value: newValue,
    });
  };

  render() {
    return (
      <div style={{ display: "flex" }}>
        <LoadingComponent isOpen={this.state.isLoading} />
        <Snackbar
          open={this.state.showError}
          autoHideDuration={6000}
          onClose={this._handleCloseSnackBar}
        >
          <MuiAlert severity="error" onClose={this._handleCloseSnackBar}>
            {this.state.message}
          </MuiAlert>
        </Snackbar>

        <AppBar style={appBarStyle()} position="fixed">
          <Toolbar>
            <Typography
              variant="h6"
              style={{
                flexGrow: 1,
                fontWeight: "bold",
                fontSize: "30px",
                textTransform: "capitalize",
              }}
            >
              {this.props.establishment != null
                ? this.state.title === "Home" ||
                  this.state.title === null ||
                  this.state.title === ""
                  ? "Tableau de bord"
                  : this.state.title
                : "Aucun restaurant"}
            </Typography>
            {/* <IconButton
              aria-label="search"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              style={{
                width: "36px",
                height: "36px",
                backgroundColor: "#7ABF92",
                color: "white",
              }}
            >
              <SearchRounded />
            </IconButton> */}

            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={this.handleMenu}
              color="secondary"
            >
              <AccountCircle style={{ width: "42", height: "42" }} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={this.state.open}
              keepMounted
              open={Boolean(this.state.open)}
              onClose={() => this.handleClose()}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem onClick={this.handleTapDisconnectButton}>
                Déconnexion
              </MenuItem>
              <MenuItem onClick={this.handleClose}>
                {(Environment.isPopina)
                  ? "Actualiser la carte Popina"
                  : "Actualiser la carte Jalia"
                }
              </MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          anchor="left"
          style={{ width: "266px", flexShrink: 0 }}
          PaperProps={{
            style: {
              backgroundColor: "#F1F1F5",
            },
          }}
        >
          <div
            className="drawerHeader"
            style={{
              width: "246px",
              textAlign: "center",
              fontSize: "40px",
              marginTop: "14px",
              color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
              fontWeight: "bold",
              padding: "10px",
              marginBottom: "1em",
            }}
          >
            Delivera
          </div>

          <Tabs
            centered
            orientation="vertical"
            value={this.state.value}
            onChange={this.handleChange}
            aria-label="Vertical tabs example"
            TabIndicatorProps={{
              style: {
                width: "10px",
              },
            }}
          >
            <CustomTab
              label="Home"
              value="/home"
              icon={
                <Avatar
                  style={{
                    color: "#474F5E",
                    backgroundColor: "white",
                    marginRight: "30px",
                  }}
                >
                  <HomeOutlined />{" "}
                </Avatar>
              }
              {...this.a11yProps(0)}
              onClick={() => this._handleTapManuItem("Home")}
            />
            <CustomTab
              label="Carte"
              value="/home/restaurant"
              icon={
                <Avatar
                  style={{
                    color: "#474F5E",
                    backgroundColor: "white",
                    marginRight: "30px",
                  }}
                >
                  <MenuBookOutlined />{" "}
                </Avatar>
              }
              {...this.a11yProps(1)}
              onClick={() => this._handleTapManuItem(Environment.isPopina ? "Popina" : "Jalia")}
            />
            {/* <CustomTab
              label="Réglage"
              icon={
                <Avatar
                  style={{
                    color: "#474F5E",
                    backgroundColor: "white",
                    marginRight: "30px",
                  }}
                >
                  <SettingsOutlined />
                </Avatar>
              }
              {...this.a11yProps(2)}
            /> */}
            <CustomTab
              label="Uber Eats"
              value="/home/ubereats"
              icon={
                <Avatar
                  style={{
                    color: "#474F5E",
                    backgroundColor: "white",
                    marginRight: "30px",
                  }}
                >
                  <img
                    src={uberEats}
                    alt="uber eats"
                    style={{
                      width: "24px",
                      height: "24px",
                      
                    }}
                  />
                </Avatar>
              }
              {...this.a11yProps(2)}
              onClick={() => this._handleTapManuItem("ubereats")}
            />
            <CustomTab
              label="HubRise"
              value="/home/hubrise"
              icon={
                <Avatar
                  style={{
                    color: "#474F5E",
                    backgroundColor: "white",
                    marginRight: "30px",
                  }}
                >
                  <img
                    src={HubRiseIcon}
                    alt="HubRise"
                    style={{
                      width: "24px",
                      height: "24px",
                      
                    }}
                  />
                </Avatar>
              }
              {...this.a11yProps(3)}
              onClick={() => this._handleTapManuItem("hubrise")}
            />
            {/* <CustomTab
              label="Deliveroo"
              icon={
                <Avatar
                  style={{
                    color: "#474F5E",
                    backgroundColor: "white",
                    marginRight: "30px",
                  }}
                >
                  <img
                    src={deliverooLogo}
                    alt="deliveroo"
                    style={{
                      width: "24px",
                      height: "24px",
                      
                    }}
                  />
                </Avatar>
              }
              {...this.a11yProps(3)}
              onClick={() => this._handleTapManuItem("deliveroo")}
            /> */}
            <CustomTab
              label="Keytchens"
              icon={
                <Avatar
                  style={{
                    color: "#474F5E",
                    backgroundColor: "white",
                    marginRight: "30px",
                  }}
                >
                  <img
                    src={KeytchensIcon}
                    alt="Keytchens"
                    style={{
                      width: "28px",
                      height: "28px",
                      
                    }}
                  />
                </Avatar>
              }
              {...this.a11yProps(4)}
              onClick={() => this._handleTapManuItem("keytchens")}
            />            
            <CustomTab
            label={`${FOXORDER_V2}`}
            icon={
              <Avatar
                style={{
                  color: "#474F5E",
                  backgroundColor: "white",
                  marginRight: "30px",
                }}
              >
                <img
                  src={foxorders_v2_logo}
                  alt={`${FOXORDER_V2}`}
                  style={{
                    width: "28px",
                    height: "28px",
                    
                  }}
                />
              </Avatar>
            }
            {...this.a11yProps(5)}
            onClick={() => this._handleTapManuItem(`${FOXORDER_V2}`)}
            />
            <CustomTab
            label='ObyPay'
            value="/home/obypay"
            icon={
              <Avatar
                style={{
                  color: "#474F5E",
                  backgroundColor: "white",
                  marginRight: "30px",
                }}
              >
                <img
                  src={obypay_logo}
                  alt='ObyPay logo'
                  style={{
                    width: "28px",
                    height: "28px",
                    
                  }}
                />
              </Avatar>
            }
            {...this.a11yProps(6)}
            onClick={() => this._handleTapManuItem('obypay')}
            />
          </Tabs>
        </Drawer>

        <div style={contentStyle()}>
          <div style={contentDivStyle}>
            {this.props.location.pathname === "/home" ? (
              <CarteContainer
                {...this.props.history}
                stores={this.state.stores}
                restaurant={this.state.restaurant}
                service={this.state.services}
              />
            ) : (
                <div></div>
              )}

            <Switch>
              <Route
                path="/home/ubereats"
                render={(history) => {
                  return <UbereatsContainer {...history} />;
                }}
              />
              <Route
                path="/home/carte"
                render={(history) => {
                  return (
                    <CarteContainer
                      stores={this.state.stores}
                      restaurant={this.state.restaurant!}
                      service={this.state.services}
                    />
                  );
                }}
              />
              <Route
                path="/home/deliveroo"
                render={(history) => {
                  return <DeliverroContainer {...history} />;
                }}
              />
              <Route
                path="/home/restaurant"
                render={(history) => {
                  return <PopinaContainer {...history} />;
                }}
              />
              <Route
                path="/home/images"
                render={(history) => {
                  return <ImageContainer {...history} />;
                }}
              />
              <Route
                path='/home/hubrise'
                render={(history) => {
                    return <HubRiseContainer {...history} />
                }}
              />
              <Route
                path='/home/keytchens'
                render={(history) => {
                    return <KeytchensContainer {...history} />
                }}
              />
              <Route
                path='/home/foxorderV2'
                render={(history) => {
                    return <FoxorderContainer {...history} />
                }}
              />
              <Route
                path="/home/restaurant"
                render={(_) => {
                  // return <ErrorBoundary><HomeContainer {...router} /></ErrorBoundary>
                  return <div></div>;
                }}
              />
              <Route
                path='/home/obypay'
                render={(history) => {
                    return <ObypayContainer {...history} />
                }}
              />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

const appBarStyle = () => {
  const size = `calc(100% - ${266}px`;
  return {
    flexGrow: 1,
    width: size,
    padding: "35px",
    backgroundColor: "white",
    color: "#474F5E",
    paddingBottom: "20px",
  };
};

const contentStyle = () => {
  const margin = `0px`;
  return {
    marginLeft: margin,
    flexGrow: 1,
  };
};

const contentDivStyle = {
  marginTop: "8em",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const CustomTab = styled(Tab)({
    backgroundColor: "#F1F1F5",
    color: "#474F5E",
    fontSize: "20px",
    textTransform: "capitalize",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    "&:hover": {
      color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
      backgroundColor: "#474F5E",
    },
    "&:active": {
      color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
      backgroundColor: "#474F5E",
    },
    wrapper: {
      width: "70%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
    },
})

export default HomeContainer;
